<template>
  <div>
    <template v-if="!logged">
      <!-- dialog de login  -->
      <loginDialog />
    </template>

    <template v-else>
      <v-menu
        min-width="190"
        left
        :isMobile="$vuetify.breakpoint.mdAndDown"
        offset-y
        transition="slide-y-transition"
      >
        <!--menu tu cuenta-->
        <template v-slot:activator="{ on }">
          <v-btn class="hidden-sm-and-down mr-2 textTNone" style="max-width:200px" text v-on="on">
            <v-icon size="28" left>mdi-account-outline</v-icon>
            <span class="text-truncate" style="max-width:120px">{{ user.displayName }}</span>
          </v-btn>
          <v-btn class="mr-3 d-md-none" icon v-on="on">
            <v-icon large>mdi-account-outline</v-icon>
          </v-btn>
        </template>
        <!--menu tu cuenta  desplegable-->
        <v-list class>
          <router-link
            v-for="route in tuCuenta"
            :key="route.path"
            :to="route.path"
            v-slot="{ href, route, navigate, isActive }"
          >
            <v-list-item :active="isActive" :href="href" @click="navigate">
              <v-list-item-action class="mr-3">
                <v-icon>{{route.meta.icon}}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ route.name }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>

          <v-list-item @click="logout()">
            <v-list-item-action class="mr-3">
              <v-icon>mdi-logout</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Logout</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
    </template>
  </div>
</template>


<script>
import { mapState, mapGetters } from "vuex";
import loginDialog from "@/components/LoginDialog.vue";
export default {
  name: "cuentaMenuUser",
  components: {
    loginDialog
  },
  data() {
    return {
      tuCuenta: [],
      items: [],
      itemsLogueado: []
    };
  },
  computed: {
    ...mapState({
      logged: state => state.auth.isLogged,
      user: state => state.auth.user,
      negocioPropio: state => state.propio.negocioPropio,
      modoGeneral: state => state.app.modoGeneral
    }),
    ...mapGetters({
      // esDomicilio: "pedido/esDomicilio"
    })
  },
  methods: {
    logout() {
      let path = "/";
      let _vm = this;
      this.$store.dispatch("auth/firebaseLogout").then(r => {
        _vm.$router.push({
          path: path
        });
      });
    }
  },
  beforeMount() {},
  mounted() {
    //crear menús
    const menuChildren = this.$router.options.routes[0].children;
    const basePath = "/";

    menuChildren.forEach(route => {
      let added = false;
      if (route.meta && route.meta.tucuenta) {
        this.tuCuenta.push({
          name: route.name,
          path: basePath + route.path
        });
        added = true;
      }

      if (route.meta && route.meta.superior) {
        if (route.meta.onlyAnonimous) {
          this.items.push({
            name: route.name,
            path: route.path
          });
          added = true;
        }
        if (route.meta.logged) {
          this.itemsLogueado.push({
            name: route.name,
            path: route.path
          });
          added = true;
        }
        if (!added) {
          this.itemsLogueado.push({
            name: route.name,
            path: route.path
          });
          this.items.push({
            name: route.name,
            path: route.path
          });
        }
      }
    });
  }
};
</script>

<style scoped>
</style>